import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';

const PlaceholderWrapper = styled.div`
  padding: 24px;
  border: 1.5px dashed #a9c7e9;
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.mobileL} {
    margin: 0 16px 24px;
  }
`;

const Placeholder = ({ text }) => (
  <PlaceholderWrapper>
    <Text type="b3">{text}</Text>
  </PlaceholderWrapper>
);

Placeholder.propTypes = {
  text: PropTypes.string,
};

export default Placeholder;
